import { HISTOGRAM_RESULTS } from 'constants/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case HISTOGRAM_RESULTS:
      return action.histogramResults || initialState;
    default:
      return state;
  }
};
